import {
  IonIcon,
  IonTitle,
  IonButton,
  IonHeader,
  IonFooter,
  IonContent,
  IonToolbar,
  IonButtons,
  ModalController,
} from '@ionic/angular/standalone';
import { AsyncPipe } from '@angular/common';
import { Component, input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { addIcons } from 'ionicons';
import { call, close } from 'ionicons/icons';

import { CallInfoComponent } from '@app/components/call-info/call-info.component';
import { CurrentCall } from '@app/interfaces/sse-notification.interface';
import { ActiveCallsService } from '@app/services/active-calls.service';

@Component({
  selector: 'app-call-popup',
  templateUrl: './call-popup.component.html',
  styleUrls: ['./call-popup.component.scss'],
  imports: [
    IonIcon,
    IonTitle,
    AsyncPipe,
    IonButton,
    IonHeader,
    IonFooter,
    IonContent,
    IonToolbar,
    IonButtons,
    CallInfoComponent,
  ],
})
export class CallPopupComponent implements OnInit {
  private modalCtrl = inject(ModalController);
  private activeCallsSrv = inject(ActiveCallsService);

  uuid = input.required<string>();

  call$?: Observable<CurrentCall | undefined>;

  constructor() {
    addIcons({ call, close });
  }

  ngOnInit(): void {
    this.call$ = this.activeCallsSrv.getCall$(this.uuid());
  }

  dismiss(): Promise<boolean> {
    return this.modalCtrl.dismiss();
  }
}
